import React from 'react';
import GenericTables from '../../../shared/components/ui/GenericTables.jsx';
import ActionMenu from '../../../shared/components/ui/ActionMenu.jsx';
import { formatFileSize, formatDate } from '../../../shared/utils/fileFormat.js';
import FileExplorerEntryIcon from './FileExplorerEntryIcon.jsx';

const baseColumns = [
  {
    key: 'icon',
    label: '',
    mobileHidden: true,
    render: (entry) => <FileExplorerEntryIcon entry={entry} />
  },
  { key: 'name', label: 'Nombre', mobilePrimary: true },
  {
    key: 'size',
    label: 'Tamaño',
    render: (entry) => (entry.type === 'folder' && !entry.size ? '—' : formatFileSize(entry.size))
  },
  { key: 'createdAt', label: 'Modificado', render: (entry) => formatDate(entry.createdAt) }
];

const FileExplorerTable = ({
  entries,
  loading,
  pagination,
  onRowClick,
  selectable = false,
  selectedIds = null,
  onToggleEntry,
  getEntryActions
}) => {
  // La selección conserva una ubicación independiente en mobile para no
  // confundirse con el menú de acciones de cada tarjeta.
  const columns = selectable
    ? [
        {
          key: 'select',
          label: '',
          isAction: true,
          mobileCardPosition: 'inline',
          render: (entry) => (
            <input
              type="checkbox"
              checked={selectedIds?.has(entry.id) || false}
              onChange={() => onToggleEntry(entry)}
              className="h-4 w-4 rounded border-line bg-surface text-amber focus:ring-amber focus:ring-offset-0 cursor-pointer"
            />
          )
        },
        ...baseColumns
      ]
    : [
        ...baseColumns,
        {
          key: 'actions',
          label: '',
          isAction: true,
          render: (entry) => <ActionMenu options={getEntryActions(entry)} />
        }
      ];

  return (
    <>
      <GenericTables
        columns={columns}
        data={entries}
        loading={loading}
        emptyMessage="No hay archivos todavía"
        showFooter
        pagination={pagination}
        // En modo selección la fila entera togglea; fuera de ese modo las
        // carpetas navegan y los archivos abren el visor (ver handleEntryRowClick).
        onRowClick={onRowClick}
        getRowClassName={(entry) => {
          const classes = [];
          if (selectedIds?.has(entry.id)) {
            // border en vez de bg: los estilos de zebra stripe de GenericTables
            // ya usan bg-*/!important, así que un bg propio pelearía por
            // especificidad; el borde no compite con esas clases.
            classes.push('border-l-4 border-l-amber');
          }
          return classes.filter(Boolean).join(' ');
        }}
      />
    </>
  );
};

export default FileExplorerTable;
